<template>
  <li class="hidden-md">
    <a :href="('tel:' + getHeaderPhoneNumber)">{{ $filters.formatPhoneNumber(getHeaderPhoneNumber) }}</a>
  </li>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'mvtHeaderContact',
  emits: ['toggleMenu'],
  inject: ['$eventBus'],
  computed:{
    ...mapGetters('glb', ['getHeaderPhoneNumber']),
  },
  methods: {
    openHotlead() {
      this.$eventBus.$emit('dialog-center', {
        name: 'mvtHotleadForm',
        trigger: this.$options.name,
        opt: {
          hotleadTitle: this.molang('header.HotleadTitle'),
          hotleadSub: this.molang('header.HotleadPara'),
          hotleadType: 'ExpertConsultConsumerGlobalHomePageBottom',
          buttonText: this.molang('header.HotleadButtionCap'),
          showZipcode: true,
        },
      });
    },

  }
};
</script>